"use client";
import React from "react";
import { useState } from "react";
import Api from "@/app/api";
import moment from "moment";
import toast from "react-hot-toast";

export default function page({ data, url }) {
  const [comment, setComment] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [expandComment, setExpandComment] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [commentError, setCommentError] = useState("");

  const showMore = () => setExpandComment(true);
  const showLess = () => setExpandComment(false);

  const date = Date.now();
  const formattedDate = moment(date).format("M/D/YYYY");

  const validateEmail = (value) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!value.trim()) {
      setEmailError("Email is required");
    } else if (!emailRegex.test(value.trim())) {
      setEmailError("Invalid email format");
    } else {
      setEmailError("");
    }
  };
  const validateComment = (value) => {
    const wordCount = value.trim().split(/\s+/).length;
    if (!value.trim()) {
      setCommentError("Comment is required");
    } else if (wordCount > 100) {
      setCommentError("Comment cannot exceed 100 words");
    } else if (wordCount < 10) {
      setCommentError("Comment cannot be less than 20 words");
    } else {
      setCommentError("");
    }
  };

  const handleComment = async () => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    // Validate email format
    if (!emailRegex.test(email)) {
      toast.error("Invalid email format");
    } else {
      try {
        const response = await Api.post(url, {
          username: name,
          comment: comment,
          date: formattedDate,
        });

        if (response.status === 200 || response.status === 201) {
          // Clear the form fields
          setName("");
          setEmail("");
          setComment("");

          // Reload the page
          window.location.reload();
        } else {
          // Handle other statuses if needed
        }
      } catch (error) {
        // Handle errors
      }
    }
  };

  return (
    <div>
      <div className=" max-md:mx-5 py-10 movie-d-comment">
        <h1 className="text-center proza-font text-[20px] text-[#011826] font-bold my-5">
          Subscribe to&nbsp;
          <span className="bg-gradient-to-r from-[#6260FA] to-[#00ECD4] bg-clip-text text-transparent">
            Cinema Drip Newsletter
          </span>
          &nbsp;and keep your inbox happy.
        </h1>
        {/* comment form */}
        <div className="bg-gradient-to-br from-[#6360fa54] to-[#00ecd47c] py-5 px-10">
          <div className="flex items-center gap-2">
            <img src="/Images/comment.png" alt="comment icon" />
            <h1 className="font-extrabold proza-font capitalize text-[24px] text-primarytext">
              {data?.comments?.length} Comments
            </h1>
          </div>
          <p className="text-[16px] text-primarytext my-6 font-medium proza-font">
            Comments On Deadline Hollywood are monitored. So don't go off topic,
            don't impersonate anyone, and don't get your facts wrong.
          </p>
          {/* inputs */}
          <p className="text-[16px] text-primarytext my-2 font-medium proza-font">
            Comment
          </p>
          {/* <textarea
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            className="border border-primarytext bg-[#AAD4DB] p-5 w-full h-40 .placeholder-gray-900"
            placeholder="Write your comment within 100 words."
            defaultValue={""}
          /> */}
          <textarea
            value={comment}
            onChange={(e) => {
              setComment(e.target.value);
              validateComment(e.target.value);
            }}
            className="border border-primarytext bg-[#AAD4DB] p-5 w-full h-40 placeholder-gray-900"
            placeholder="Write your comment within 100 words."
          />
          {commentError && (
            <p className="text-red-500 text-sm mt-1">{commentError}</p>
          )}
          <p className="text-[16px] capitalize outline-0 text-primarytext my-2 font-medium proza-font">
            name
          </p>
          <input
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="border border-primarytext bg-[#AAD4DB] p-3 w-full .placeholder-gray-900"
          />
          <p className="text-[16px] capitalize outline-0 text-primarytext my-2 font-medium proza-font">
            Email
          </p>
          <input
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              validateEmail(e.target.value);
            }}
            className="border border-primarytext bg-[#AAD4DB] p-3 w-full .placeholder-gray-900"
          />
          {emailError && (
            <p className="text-red-500 text-sm mt-1">{emailError}</p>
          )}
          <button
            disabled={!comment || !name || !email}
            onClick={handleComment}
            className={`w-full mt-5 py-3 bg-gradient-to-r from-[#6260FA] to-[#00ECD4] proza-font text-white font-bold rounded-full text-xl ${
              !comment || !name || !email ? "opacity-50 cursor-not-allowed" : ""
            }`}
          >
            Post a comment
          </button>
          {/* comments list */}
          <div>
            {data?.comments
              ?.slice(0, expandComment ? data?.comments?.length : 5)
              .map((data, index) => (
                <>
                  {/* comment 1 */}
                  <div key={index}>
                    <div className="bg-gradient-to-r from-[#6260FA] to-[#00ECD4] w-full h-[3px] my-4">
                      {/* gradient line */}
                    </div>
                    <div className="flex gap-2 items-end">
                      <h1 className="font-bold proza-font text-primarytext text-[20px]">
                        {data?.username || <>Anonymous</>}
                      </h1>
                      <p className="text-[#01182694] text-[14px] italic">
                        On{" "}
                        {moment(`${data?.date}`, "M/D/YYYY").format(
                          "MMMM D YYYY"
                        )}
                      </p>
                    </div>
                    <article className="my-6 text-[20px] text-primarytext poppins font-medium">
                      {data?.comment}
                    </article>
                    {/* <button className="bg-gradient-to-r from-[#6260FA] to-[#00ECD4] text-transparent bg-clip-text font-bold proza-font text-[16px]">
                      Reply
                    </button> */}
                  </div>
                </>
              ))}
            {data?.comments?.length > 5 && (
              <button
                onClick={expandComment ? showLess : showMore}
                className="bg-gradient-to-r from-[#6260FA] to-[#00ECD4] text-transparent bg-clip-text font-bold proza-font text-[20px] m-auto flex mt-10"
              >
                {expandComment ? "Show Less" : "See All"}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  className="w-6 h-6 bg-gradient-to-r from-[#6260FA] to-[#00ECD4] text-transparent bg-clip-text"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="m19.5 8.25-7.5 7.5-7.5-7.5"
                  />
                </svg>
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
